'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _classCallCheck = require('@babel/runtime-corejs3/helpers/classCallCheck');
var _createClass = require('@babel/runtime-corejs3/helpers/createClass');
var _concatInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/concat');
var _includesInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/includes');
require('../error/index.js');
require('../utils/index.js');
var attributeType_model = require('./attribute-type.model.js');
var formatValidator = require('../utils/format-validator.js');
var graphStudioError_model = require('../error/graph-studio-error.model.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _classCallCheck__default = /*#__PURE__*/_interopDefaultLegacy(_classCallCheck);
var _createClass__default = /*#__PURE__*/_interopDefaultLegacy(_createClass);
var _concatInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_concatInstanceProperty);
var _includesInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_includesInstanceProperty);

/**
 * GSQL Attribute json representation interface following the format:
 *   {
 *     "AttributeName": string,
 *     "AttributeType": GSQLAttributeTypeJson,
 *     ["Nullable": boolean],
 *     ["DefaultValue": string],
 *     ["Alias": string]
 *   }
 *
 * @export
 * @interface GSQLAttributeJson
 */

/**
 * Attribute describes a vertex attribute or edge attribute, including the
 * attribute's name, type and additional properties like default value and alias.
 *
 * @export
 * @class Attribute
 */
var Attribute = /*#__PURE__*/function () {
  /**
   * Creates an instance of Attribute.
   *
   * @memberof Attribute
   */
  function Attribute() {
    _classCallCheck__default["default"](this, Attribute);
    this.name = '';
    this.type = new attributeType_model.AttributeType();
    this.hasNullable = this.hasDefaultValue = this.hasAlias = this.nullable = false;
    this.defaultValue = this.alias = '';
    this.isPrimaryKey = this.isPartOfCompositeKey = this.primaryIdAsAttribute = false;
    this.hasIndex = false;
    this.isUsingNewSyntax = false;
    this.isDiscriminator = false;
  }

  /**
   * Clone the attribute.
   *
   * @returns {Attribute}
   * @memberof Attribute
   */
  return _createClass__default["default"](Attribute, [{
    key: "clone",
    value: function clone() {
      var attribute = new Attribute();
      attribute.name = this.name;
      attribute.type = this.type.clone();
      attribute.hasNullable = this.hasNullable;
      attribute.nullable = this.nullable;
      attribute.hasDefaultValue = this.hasDefaultValue;
      attribute.defaultValue = this.defaultValue;
      attribute.hasAlias = this.hasAlias;
      attribute.alias = this.alias;
      attribute.isPrimaryKey = this.isPrimaryKey;
      attribute.isPartOfCompositeKey = this.isPartOfCompositeKey;
      attribute.primaryIdAsAttribute = this.primaryIdAsAttribute;
      attribute.isUsingNewSyntax = this.isUsingNewSyntax;
      attribute.hasIndex = this.hasIndex;
      attribute.indexName = this.indexName;
      attribute.isDiscriminator = this.isDiscriminator;
      return attribute;
    }

    /**
     * Load Attribute from GSQL Attribute json representation.
     *
     * @param {GSQLAttributeJson} attributeJson GSQL Attribute json representation
     * @returns {Attribute}
     * @memberof Attribute
     */
  }, {
    key: "loadFromGSQLJson",
    value: function loadFromGSQLJson(attributeJson) {
      // AttributeName
      this.name = attributeJson.AttributeName;
      var validateName = formatValidator.FormatValidator.isName(this.name);
      if (!validateName.success) {
        throw new graphStudioError_model.GraphStudioError("Invalid attribute name \"".concat(this.name, "\". ") + validateName.message);
      }

      // AttributeType
      this.type.loadFromGSQLJson(attributeJson.AttributeType);

      // Nullable
      if ('Nullable' in attributeJson) {
        this.hasNullable = true;
        this.nullable = attributeJson.Nullable;
      } else {
        this.hasNullable = this.nullable = false;
      }
      // DefaultValue
      if ('DefaultValue' in attributeJson) {
        this.hasDefaultValue = true;
        this.defaultValue = attributeJson.DefaultValue;
      } else {
        this.hasDefaultValue = false;
        this.defaultValue = '';
      }
      // Alias
      if ('Alias' in attributeJson) {
        this.hasAlias = true;
        this.alias = attributeJson.Alias;
      } else {
        this.hasAlias = false;
        this.alias = '';
      }

      // IsPrimaryKey
      if ('IsPrimaryKey' in attributeJson) {
        this.isPrimaryKey = attributeJson.IsPrimaryKey;
      }

      // IsPartOfCompositeKey
      if ('IsPartOfCompositeKey' in attributeJson) {
        this.isPartOfCompositeKey = attributeJson.IsPartOfCompositeKey;
      }

      // PrimaryIdAsAttribute
      if ('PrimaryIdAsAttribute' in attributeJson) {
        this.primaryIdAsAttribute = attributeJson.PrimaryIdAsAttribute;
      }

      // Vertex created using PRIMARY KEY or COMPOSITE KEY.
      if ('IsUsingNewSyntax' in attributeJson) {
        this.isUsingNewSyntax = true;
      }
      if ('HasIndex' in attributeJson) {
        this.hasIndex = attributeJson.HasIndex;
        if (this.hasIndex) {
          this.indexName = attributeJson.IndexName;
        }
      }
      if ('IsDiscriminator' in attributeJson) {
        this.isDiscriminator = attributeJson.IsDiscriminator;
      }
      return this;
    }

    /**
     * Dump Attribute into GSQL Attribute json representation.
     *
     * @returns {GSQLAttributeJson}
     * @memberof Attribute
     */
  }, {
    key: "dumpToGSQLJson",
    value: function dumpToGSQLJson() {
      var attributeJson = {
        AttributeName: this.name,
        AttributeType: this.type.dumpToGSQLJson()
      };
      if (this.hasNullable) {
        attributeJson.Nullable = this.nullable;
      }
      if (this.hasDefaultValue) {
        attributeJson.DefaultValue = this.defaultValue;
      }
      if (this.hasAlias) {
        attributeJson.Alias = this.alias;
      }
      if (this.hasIndex) {
        attributeJson.HasIndex = this.hasIndex;
        if (this.indexName) {
          attributeJson.IndexName = this.indexName;
        }
      }
      if (this.isDiscriminator) {
        attributeJson.IsDiscriminator = this.isDiscriminator;
      }
      return attributeJson;
    }

    /**
     * Semantic check to be valid attribute.
     *
     * @returns {ValidateResult}
     * @memberof Edge
     */
  }, {
    key: "semanticCheck",
    value: function semanticCheck() {
      var _context3;
      // 1. Attribute name must be valid name.
      var validateName = formatValidator.FormatValidator.isName(this.name);
      if (!validateName.success) {
        var _context;
        return {
          success: false,
          message: _concatInstanceProperty__default["default"](_context = "Invalid attribute name \"".concat(this.name, "\". ")).call(_context, validateName.message)
        };
      }
      // 2. Attribute type must be valid type.
      if (this.isDiscriminator) {
        if (!_includesInstanceProperty__default["default"](attributeType_model.supportedDiscriminatorAttributeTypes).call(attributeType_model.supportedDiscriminatorAttributeTypes, this.type.name)) {
          return {
            success: false,
            message: "Please select discriminator attribute type for attribute \"".concat(this.name, "\".")
          };
        }
      } else {
        if (!_includesInstanceProperty__default["default"](attributeType_model.supportedAttributeTypes).call(attributeType_model.supportedAttributeTypes, this.type.name)) {
          return {
            success: false,
            message: "Please select attribute type for attribute \"".concat(this.name, "\".")
          };
        }
      }

      // 3. Cannot have unsupported key type name and value type name.
      if (this.type.hasKeyTypeName && !_includesInstanceProperty__default["default"](attributeType_model.supportedMapKeyTypes).call(attributeType_model.supportedMapKeyTypes, this.type.keyTypeName)) {
        return {
          success: false,
          message: "".concat(this.type.keyTypeName, " is unsupported map key type now.")
        };
      }
      if (this.type.hasValueTypeName && !_includesInstanceProperty__default["default"](attributeType_model.supportedContainerValueTypes).call(attributeType_model.supportedContainerValueTypes, this.type.valueTypeName)) {
        return {
          success: false,
          message: "".concat(this.type.valueTypeName, " is unsupported attribute container value type now.")
        };
      }
      // 4. Default value validation check
      if (this.hasDefaultValue) {
        var _context2;
        if (this.type.name === 'INT') {
          // 1. Validate INT attribute default value.
          var validateDefault = formatValidator.FormatValidator.isInt(this.defaultValue);
          if (!validateDefault.success) {
            return this.returnDefaultValueValidationFailureResult();
          }
        } else if (this.type.name === 'UINT') {
          // 2. Validate UINT attribute default value.
          var _validateDefault = formatValidator.FormatValidator.isUInt(this.defaultValue);
          if (!_validateDefault.success) {
            return this.returnDefaultValueValidationFailureResult();
          }
        } else if (this.type.name === 'DOUBLE' || this.type.name === 'FLOAT') {
          // 3. Validate real number attribute default value.
          var _validateDefault2 = formatValidator.FormatValidator.isReal(this.defaultValue);
          if (!_validateDefault2.success) {
            return this.returnDefaultValueValidationFailureResult();
          }
        } else if (this.type.name === 'BOOL') {
          // 4. Validate BOOL attribute default value.
          var _validateDefault3 = formatValidator.FormatValidator.isBoolean(this.defaultValue);
          if (!_validateDefault3.success) {
            return this.returnDefaultValueValidationFailureResult();
          }
        } else if (this.type.name === 'DATETIME') {
          // 5. Validate DATETIME attribute default value.
          var _validateDefault4 = formatValidator.FormatValidator.isDatetime(this.defaultValue);
          if (!_validateDefault4.success) {
            return this.returnDefaultValueValidationFailureResult();
          }
        } else if (_includesInstanceProperty__default["default"](_context2 = ['LIST', 'SET', 'MAP', 'UDT']).call(_context2, this.type.name)) {
          // 6. List, Set, Map or UDT attribute cannot have default value.
          if (this.hasDefaultValue) {
            return {
              success: false,
              message: "".concat(this.type.name, " cannot have default value.")
            };
          }
        }
      }
      // 5. Container type attributes must have container value type.
      if (_includesInstanceProperty__default["default"](_context3 = ['LIST', 'SET', 'MAP']).call(_context3, this.type.name)) {
        if (!this.type.hasValueTypeName) {
          var _context4;
          return {
            success: false,
            message: _concatInstanceProperty__default["default"](_context4 = "Please select value type for ".concat(this.type.name, " attribute \"")).call(_context4, this.name, "\".")
          };
        }
      }
      // 6. Map type attributes must have key type.
      if (this.type.name === 'MAP' && !this.type.hasKeyTypeName) {
        var _context5;
        return {
          success: false,
          message: _concatInstanceProperty__default["default"](_context5 = "Please select key type for ".concat(this.type.name, " attribute \"")).call(_context5, this.name, "\".")
        };
      }
      // 7. UDT type attributes must specify the UDT name.
      if (this.type.name === 'UDT' && !this.type.hasTupleName) {
        return {
          success: false,
          message: "Please select user defined tuple name."
        };
      }
      // 8. UDT value type of a container type attributes must specify the UDT name.
      if (this.type.valueTypeName === 'UDT' && !this.type.hasValueTypeTupleName) {
        return {
          success: false,
          message: "Please select user defined value tuple name."
        };
      }
      // 9. Currently GraphStudio doesn't support vertex created using PRIMARY KEY or COMPOSITE KEY.
      if (this.isUsingNewSyntax) {
        return {
          success: false,
          message: 'PRIMARY KEY and Composite Key are not supported. ' + 'You must use PRIMARY_ID when creating your schema.'
        };
      }
      return {
        success: true
      };
    }

    /**
     * Construct default value validation failure result.
     *
     * @private
     * @returns {ValidateResult}
     * @memberof Attribute
     */
  }, {
    key: "returnDefaultValueValidationFailureResult",
    value: function returnDefaultValueValidationFailureResult() {
      var _context6;
      return {
        success: false,
        message: _concatInstanceProperty__default["default"](_context6 = "Attribute \"".concat(this.name, "\"'s default value \"")).call(_context6, this.defaultValue, "\" ") + "is invalid ".concat(this.type.name, ".")
      };
    }
  }]);
}();

exports.Attribute = Attribute;
